<template>
    <div class="recommend-route-container">
      <div class="recommend-route-wrapper" @scroll="handleScroll" ref="recommendRoute">
        <template v-if="!loading && !recommendRouteList.length">
          <div class="empty-route">
            暂无推荐路线
          </div>
          <div class="back-btn" @click="back">返回</div>
        </template>
        <RouteListItem v-for="item in recommendRouteList" :key="item.id" :route-info="item" />
      </div>
    </div>
</template>

<script>
import { getRecommendRouteList } from "../../server/recommend-route"
import { mapGetters } from "vuex"
import RouteListItem from "./components/RouteListItem"

export default {
  name: "RecommendRoute",
  components: { RouteListItem },
  data() {
    return {
      recommendRouteList: [],
      scrollTop: 0,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      activityId: "activityInfo/activityId"
    })
  },
  activated() {
    this.getRecommendRouteList()
    this.$refs.recommendRoute.scrollTop = this.scrollTop
  },
  methods: {
    getRecommendRouteList() {
      this.loading = true
      getRecommendRouteList({
          params: { activityId: this.activityId },
          showLoading: true
        }
      ).then((data) => {
        this.recommendRouteList = data || []
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })
    },
    handleScroll(e) {
      this.scrollTop = e.target.scrollTop
    },
    back() {
      const query = { id: this.activityId }
      const shopId = this.$route.query?.shopId
      if (shopId) {
        query.shopId = shopId
      }
      this.$router.replace({ path: "/homePage", query })
    },
  }
}
</script>

<style lang="scss" scoped>
.recommend-route-container {
  width: 100%;
  height: 100%;
  padding: 0.22rem 0.2rem 0 0.2rem;
  overflow-y: hidden;
  background-image: url('../../assets/images/banner.png');
  // background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #f7f7f7;
}

.recommend-route-wrapper {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0 -0.04rem 0.08rem 0 rgba(113, 108, 98, 0.2);
  border-radius: 0.14rem 0.14rem 0 0;
  padding: 0 0.3rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.empty-route {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.8rem;
  height: 5.66rem;
  background: url("../../assets/images/bg_map_default.png") no-repeat;
  background-size: contain;
  font-size: 0.28rem;
  color: #B23F00;
  font-weight: 400;
  margin-top: 1.4rem;
}

.back-btn {
  width: 3.2rem;
  height: 0.75rem;
  margin: 0.24rem auto;
  font-size: 0.3rem;
  line-height: 0.75rem;
  text-align: center;
  color: #ffffff;
  font-weight: 400;
  border-radius: 0.38rem;
  background-image: linear-gradient(180deg, #FF601A 0%, #DC0808 100%);
}
</style>
